import { render, staticRenderFns } from "./QuestionComponent.vue?vue&type=template&id=80ee3a34&scoped=true&"
import script from "./QuestionComponent.vue?vue&type=script&lang=js&"
export * from "./QuestionComponent.vue?vue&type=script&lang=js&"
import style0 from "./QuestionComponent.vue?vue&type=style&index=0&id=80ee3a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ee3a34",
  null
  
)

export default component.exports